import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { QuestionCircleIcon, ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import { BodyText, HeadlineText, TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LearnMoreButton } from 'components/page_elements';
const containerBorderCss = "c56grs2";
const containerIsPhoneCss = "c1sr7p01";
const containerCss = "cii121x";
const Container = forwardRef((props, ref) => {
  const {
    border,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerBorderCss]: border,
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const imageContainerCss = "i1stx44f";
const ImageContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(imageContainerCss, props.className)} />;
});
const textContainerIsPhoneCss = "t1xigbot";
const textContainerCss = "t11bdx6w";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, {
    [textContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const bodyContainerCss = "bqzla0c";
const BodyContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyContainerCss, props.className)} />;
});
const linkContainerCss = "l1xt09o6";
const LinkContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(linkContainerCss, props.className)} />;
});
const styledListCss = "s1prcctd";
const StyledList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(styledListCss, props.className)} />;
});
const footnoteTextCss = "fsjyheu";
const FootnoteText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'small';
  return <Component ref={ref} {...restProps} className={classNames(footnoteTextCss, props.className)} />;
});
const RecapsSubtitleContent = ({
  contentKey
}) => <div>
    <BodyText size="medium" color="standard">
      {I18n.t(`publisher.empty_state.${contentKey}.subtitle`)}
    </BodyText>
    <FootnoteText>
      {I18n.t('publisher.billing.meeting_intelligence.subtitle_footnote_downgrade')}
    </FootnoteText>
  </div>;

// i18n-tasks-use t('publisher.empty_state.#{contentKey}.eyebrow')
// i18n-tasks-use t('publisher.empty_state.#{contentKey}.title')
// i18n-tasks-use t('publisher.empty_state.#{contentKey}.subtitle')
// i18n-tasks-use t('publisher.empty_state.#{contentKey}.subtitle_footnote')
// i18n-tasks-use t('publisher.empty_state.#{contentKey}.list_items')
// i18n-tasks-use t('publisher.empty_state.#{contentKey}.primary_button')
export const LeftRightEmptyState = ({
  contentKey,
  iconImage,
  eyebrowText,
  border = false,
  preview = false,
  hideLearnMore = false,
  onClickLearnMore,
  actionButton
}) => {
  const isRecapsContent = contentKey === 'recaps' || contentKey === 'recaps_mi_enabled';
  const renderSubtitleContent = () => {
    if (isRecapsContent) {
      return <RecapsSubtitleContent contentKey={contentKey} />;
    }
    return <BodyText size="medium" color="standard">
        {HtmlParser(I18n.t(`publisher.empty_state.${contentKey}.subtitle`))}
      </BodyText>;
  };
  return <Container data-testid="empty-state-left-right" border={border}>
      <BodyContainer>
        <TextContainer>
          {eyebrowText && <TitleText level={1} variant="eyebrow" color={colorTextSecondary} data-testid="empty-state-eyebrow">
            {I18n.t(`publisher.empty_state.${contentKey}.eyebrow`)}
          </TitleText>}
          <HeadlineText level={2} size="medium">
            {I18n.t(`publisher.empty_state.${contentKey}.title`)}
          </HeadlineText>
          {preview ? HtmlParser(I18n.t(`publisher.empty_state.${contentKey}.list_items`), {
          UnorderedList: StyledList
        }) : renderSubtitleContent()}
          {!hideLearnMore && <LearnMoreButton onClick={onClickLearnMore} aria-label={I18n.t('publisher.empty_state.learn_more')}>
            <LinkContainer>
              <QuestionCircleIcon />
              {I18n.t('publisher.empty_state.learn_more')}
              <ArrowChevronRightMiniIcon />
            </LinkContainer>
          </LearnMoreButton>}
          {actionButton}
        </TextContainer>
      </BodyContainer>
      {iconImage && <ImageContainer>
        <img src={iconImage} alt="" width="100%" height="100%" />
      </ImageContainer>}
    </Container>;
};

require("./left_right_empty_state.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./left_right_empty_state.js");